/** Un CSV d'import lu : en-têtes normalisés, puis une liste de cellules par ligne. */
export type SemicolonCsv = { header: string[], rows: string[][] }

/** En-tête comparé sans casse ni accents : « Prénom » vaut `prenom`. */
function headerKey(cell: string): string {
  return cell.trim().toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '')
}

/**
 * Lecture commune des imports d'apprenants (séparateur `;`, comme l'export) :
 * BOM ignoré, lignes vides filtrées, en-têtes normalisés. `null` pour un
 * fichier vide. Les colonnes se retrouvent ensuite par leur nom.
 */
export function readSemicolonCsv(text: string): SemicolonCsv | null {
  const lines = text.replace(/^\uFEFF/, '').split(/\r?\n/).filter(line => line.trim() !== '')
  if (lines.length === 0) return null
  return { header: lines[0].split(';').map(headerKey), rows: lines.slice(1).map(line => line.split(';')) }
}

/** Valeur d'une colonne nommée, vide si la colonne ou la cellule manque. */
export function cellOf(csv: SemicolonCsv, row: string[], column: string): string {
  const index = csv.header.indexOf(column)
  return index === -1 ? '' : (row[index] ?? '').trim()
}

/** Société et service d'un utilisateur (#277), colonnes facultatives des deux imports. */
export type Affiliation = { company?: string, department?: string }

/** Colonnes `societe` et `service` d'une ligne ; une cellule vide ou absente est omise. */
export function affiliationOf(csv: SemicolonCsv, row: string[]): Affiliation {
  const company = cellOf(csv, row, 'societe')
  const department = cellOf(csv, row, 'service')
  return { ...(company && { company }), ...(department && { department }) }
}
